import React from 'react'
import { Badge, Modal } from 'antd'

import fetch from '../fetch';
import utils from '../../utils'

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const columns = utils.columns(
    [
        {   
            key:'$index', 
            label: '序号'
        },
        {
            key:'evalName', 
            label: '问卷名称'
        },
        {
            key:'state', label: '状态', 
            render: (state) => {
                return state == 0 ? 
                        <span><Badge status="success" />已发布</span> 
                        : 
                        <span><Badge status="warning" />未发布</span>; 
            }
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let evalId = keywords.evalId
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch
        .get('survey/evalquery/' + (evalId ? evalId : 0) + '?' + params.join('&'))
        .then(response => {
            if(response.code === 200) {
                return response.payload.data
            }
        })
        .then(data => (
                Object.assign({
                    result: data.dataList || [],
                    selects: (data.dataList || []).map(d => ({
                        value: d.evalId,
                        checked: false,
                        name: d.evalName
                    })),
                    checked: false,
                    total: data.total,
                    pageIndex: data.pageNum,
                    pageSize: data.pageSize,
                    notify: (data || []).length ? '' : '暂无数据...'
                })
            )
    )
}

const publishEval = (closeLoading) => {
    let evalIds = DataGrid.selections
    if(evalIds.length > 0) {
        Modal.confirm({
            title: '发布公共题库确认',
            content: '是否发布所选的公共题库？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                publish(evalIds).then((response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk: () => {
                                DataGrid.selections = []
                                DataGrid.selectData = []
                                DataGrid.refresh()
                            },
                        });
                    }
                }))
            },
            onCancel: () => {
                closeLoading()
                DataGrid.selections = []
                DataGrid.selectData = []
            }
        })
    } else {
        Modal.error({
            title: '请先选择一项或者多项',
            content: '只要勾选一项或者多项后才能删除！',
            okText: '确认',
            onOk: () => {
                closeLoading()
                DataGrid.selections = []
                DataGrid.selectData = []
            }
        })
    }
}

const publish = (ids) => {
    return fetch
            .post("survey/publish", ids)
            .then((response) => response)
}

const callbackEval = (closeLoading) => {
    let evalIds = DataGrid.selections
    if(evalIds.length > 0) {
        Modal.confirm({
            title: '撤回公共题库确认',
            content: '是否撤回所选的公共题库？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                callback(evalIds).then((response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk: () => {
                                closeLoading()
                                DataGrid.selections = []
                                DataGrid.selectData = []
                            },
                        });
                    }
                }))
            },
            onCancel: () => {
                closeLoading()
                DataGrid.selections = []
                DataGrid.selectData = []
            }
        })
    } else {
        Modal.error({
            title: '请先选择一项或者多项',
            content: '只要勾选一项或者多项后才能撤回！',
            okText: '确认',
            onOk: () => {
                closeLoading()
                DataGrid.selections = []
                DataGrid.selectData = []
            }
        })
    }
}

const callback = (ids) => {
    return fetch
        .post("survey/evaldelete", ids)
        .then((response) => response)
}


export default {
    columns,
    onSelect,
    onSelectData,
    setRefresh,
    querySearch,
    publishEval,
    callbackEval
}

